export default "Afprøv om jeres hjemmelavede både kan sejle. Det er et spændende øjeblik - vil bådene flyde eller synke? ";